import APIBase from "./apiBase";

export enum CharityStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
  HIDDEN = "hidden",
}

export interface Charity {
  id: string;
  name: string;
  url: string | null;
  blurb: string | null;
  logoUrl: string | null;
  heroUrl: string | null;
  status: CharityStatus | null;
}

export const getAll = async (): Promise<Charity[]> => {
  const { data } = await APIBase.get<Charity[]>("/charities");
  return data;
};

export const get = async (id: string): Promise<Charity> => {
  const { data } = await APIBase.get<Charity>(`/charities/${id}`);
  return data;
};

export const create = async (
  charityData: Omit<Charity, "id">,
): Promise<Charity> => {
  const { data } = await APIBase.post<Charity>("/charities", charityData);
  return data;
};

export const update = async (
  id: string,
  updateData: Partial<Charity>,
): Promise<Charity> => {
  const { data } = await APIBase.patch<Charity>(`/charities/${id}`, updateData);
  return data;
};

export const remove = async (id: string): Promise<void> => {
  await APIBase.delete(`/charities/${id}`);
};
